// extracted by mini-css-extract-plugin
export default {"registerContainer":"styles_registerContainer__TBHWG","registerLogo":"styles_registerLogo__XRcVi","registerLogoHidden":"styles_registerLogoHidden__u2Csj"};